<template>
  <div>
    <div >
      <div class="categorias">Molde Aberto</div>

      <div class="items-row-img">
        <div class="img-exp">
         <!-- Condicional de Fotos  -->
          <div v-if="data.IMG_MA_F_L_FIXO != null" class="conteudo">
            <img :src="this.$store.state.ImgURL + data.IMG_MA_F_L_FIXO+'.webp'" alt="Não Aplicável" />
          </div>
          <div v-else class="conteudo">Não Aplicável</div>
          <!--  -->
          <div class="legenda">Face do Lado Fixo</div>
        </div>
        <div class="img-exp">
           <!-- Condicional de Fotos  -->
          <div v-if="data.IMG_MA_F_L_MOVEL != null" class="conteudo">
            <img :src="this.$store.state.ImgURL + data.IMG_MA_F_L_MOVEL+'.webp'" alt="Não Aplicável" />
          </div>
          <div v-else class="conteudo">Não Aplicável</div>
          <!--  -->
          <div class="legenda">Face do Lado Móvel</div>
        </div>

        <div class="img-exp">
             <!-- Condicional de Fotos  -->
          <div v-if="data.IMG_MA_EXTRA != null" class="conteudo">
            <img :src="this.$store.state.ImgURL + data.IMG_MA_EXTRA+'.webp'" alt="Não Aplicável" />
          </div>
          <div v-else class="conteudo">Não Aplicável</div>
          <!--  -->
          
          <div class="legenda" v-if="!data.IMG_MA_EXTRA_DESC">Imagem Extra</div>
           <div class="legenda" v-else>{{data.IMG_MA_EXTRA_DESC}}</div>
        </div>

   
      </div>
    </div>
  </div>
</template>

<script>
export default {
props : {
  data : Object
}


};
</script>

<style>
.m-t{
    margin-top: 0.5rem;
}
</style>